// Small shared building blocks for the inventory pages.

import { Inbox } from 'lucide-react';

export function EmptyState({ icon: Icon = Inbox, title, hint, action }) {
  return (
    <div className="card" style={{ textAlign: 'center', padding: '56px 24px' }}>
      <Icon size={40} style={{ color: 'var(--g-text-3)' }} />
      <p style={{ marginTop: 14, fontWeight: 500 }}>{title}</p>
      {hint && (
        <p style={{ marginTop: 4, color: 'var(--g-text-2)', fontSize: 13 }}>{hint}</p>
      )}
      {action && <div style={{ marginTop: 18 }}>{action}</div>}
    </div>
  );
}

// Labeled form field wrapper.
export function Field({ label, children, hint }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <label className="field-l">{label}</label>
      {children}
      {hint && (
        <p style={{ fontSize: 11, color: 'var(--g-text-3)', margin: '4px 0 0' }}>{hint}</p>
      )}
    </div>
  );
}

// A segmented control for picking from a small enum (status, severity, etc.).
export function Segmented({ value, onChange, options }) {
  return (
    <div
      style={{
        display: 'inline-flex',
        background: 'var(--g-bg-soft)',
        borderRadius: 'var(--g-r-md)',
        padding: 3,
        gap: 2,
      }}
    >
      {options.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            style={{
              border: 0,
              borderRadius: 'var(--g-r-sm)',
              padding: '6px 12px',
              fontSize: 13,
              fontWeight: 500,
              cursor: 'pointer',
              background: active ? 'var(--g-surface)' : 'transparent',
              color: active ? 'var(--g-text)' : 'var(--g-text-2)',
              boxShadow: active ? 'var(--g-e1)' : 'none',
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
